/**
 * The settings backend stores values as varchar, so booleans round-trip as strings.
 * Treat anything except an explicit false-marker ('0', 'false', '') as enabled,
 * which makes the flag default to true for tenants that don't have it persisted yet.
 */
export function parseUseDayBookings(raw: unknown): boolean {
    if (typeof raw === 'boolean') {
        return raw;
    }
    if (raw == null) {
        return true;
    }
    const normalized = String(raw).trim().toLowerCase();
    return normalized !== '0' && normalized !== 'false' && normalized !== '';
}
